import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
export default function NewFaq() {
  const data=[
    {
      id:"q1",
      ques:"1. Ano ang mga Chips?",
      ans:"Ang mga Chips ay ang iyong in-game na pera na ginagamit para maglaro ng mga poker game at torneo. Maaari kang mag-claim ng daily at hourly (bawat 60 minuto) at maaari rin itong makuha sa pamamagitan ng panonood ng mga ad o pagkumpleto ng mga gawain."
    },
    {
      id:"q2",
      ques:"2. Naubusan na ako ng Chips. Ano ang gagawin ko?",
      ans:"Maaari kang mag-claim ng daily at hourly (bawat 60 minuto). Maaari ka ring kumita ng higit pa sa pamamagitan ng panonood ng mga ad o pagkumpleto ng mga reward na gawain."
    },
    {
      id:"q3",
      ques:"3. Ano ang mga Reward Points?",
      ans:"Ang mga Reward Points ay kinukuha sa pamamagitan ng paglalaro — sa pamamagitan ng pag-rank sa mga leaderboard, pagtatapos sa mga bayad na posisyon ng torneo, o pagkumpleto ng mga gawain. Maaari itong i-redeem sa Baazi Store para sa mga alok at gift card mula sa mga nangungunang brand."
    },
    {
      id:"q4",
      ques:"4. Paano ako kumita ng Reward Points?",
      ans:"Maglaro ng mga laro, umakyat sa mga leaderboard, kumpletuhin ang mga pang-araw-araw na gawain, o matapos sa mga posisyon ng torneo payout para kumita ng Reward Points."
    },
    {
      id:"q5",
      ques:"5. Paano ko magagamit ang mga Reward Points?",
      ans:"Buksan ang Baazi Store sa app, piliin ang iyong ninanais na alok o voucher, at i-redeem gamit ang iyong mga available na Reward Points."
    },
    {
      id:"q6",
      ques:"6. Maaba bang i-redeem ang mga Reward Points para sa cash?",
      ans:"Hindi. Ang mga Reward Points ay maaari lamang gamitin para mag-redeem ng mga alok o voucher sa Baazi Store."
    },
    {
      id:"q7",
      ques:"7. Na-redeem ko na ang aking mga Reward Points ngunit hindi ko natanggap ang item.",
      ans:"Mangyaring payagan ang hanggang 48 oras para sa pagpoproseso. Kung hindi natanggap, makipag-ugnayan sa Support kasama ang iyong pangalan ng reward at petsa ng pag-redeem para sa tulong."
    },
    {
      id:"q8",
      ques:"8. Maaari ko bang ilipat ang mga Chips o Reward Points sa ibang manlalaro?",
      ans:"Hindi. Ang parehong Chips at Reward Points ay hindi maaaring ilipat at nakakonekta lamang sa iyong account."
    },
    {
      id:"q9",
      ques:"9. Saan ko masisita ang aking mga balanse?",
      ans:"Maaari mong tingnan ang iyong mga Chips at Reward Points sa seksyon ng Wallet ng app anumang oras."
    },
    {
      id:"q10",
      ques:"10. Hindi pa na-update ang aking balanse. Ano ang gagawin ko?",
      ans:"I-refresh ang app o mag-log out at mag-log in ulit. Kung nagpapatuloy ang isyu, makipag-ugnayan sa Support kasama ang iyong username at mga detalye ng gameplay."
    },

  ]
  return (
    <div>
      <Topheader colorbox="newfaq_header_color" title="Mga Madalas Itanong" />
      <div className="main-container mb-5 mt-4 ">
        
        <div className={style.btm_safe}>
          <div id="accordion">
            {data.map((item,index)=>{
          return(
            <div key={index} className={`${style.box}`}>
            <div className={`${style.accordionHeader} collapsed`} data-bs-toggle="collapse" href={`#${item.id}`}>
              <div className={style.title_box}>
                <span className={style.title}>{item.ques}</span>
                <svg className={style.arrowIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12.0002 7L8.00051 11L4.00025 7" stroke="#041B67" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>


            <div id={item.id} className='collapse mt-2' data-bs-parent="#accordion">
              <div className={style.desc}>
                {item.ans}
              </div>
            </div>
            </div>
             )
        })}
          </div>
        </div>
         

        
      </div>

      <div className={style.btm_fixed_area}>
        <div className={style.btn}>
         <a href='mailto:playerrelations@pokerbaazi.com' target='_blank' rel="noreferrer" style={{color:'white'}}>Sumulat sa Amin</a>

        </div>

      </div>
    </div>
  )
}
